export interface ReleaseDate {
  date?: string;
}

export interface Entity {
  id?: string;
  name?: string;
}

interface Meta {
  id_main_season?: string;
  id_main_series?: string;
  main_season_number?: number;
  name_main_season?: string;
  name_main_series?: string;
}

export interface GalleryItem {
  added_at?: ReleaseDate;
  comments?: string;
  copyright?: string;
  description?: string;
  file_name?: string;
  id?: string;
  metas?: Meta;
  movie?: Entity;
  person?: string;
  series?: Entity;
}

export interface FieldsInfos {
  className: string;
  field: keyof GalleryItem;
  prefix: Node | null;
  transKey: string;
}
export interface GalleryData {
  currentIndex: number;
  items: GalleryItem[];
}

export interface GalleryComponents {
  container?: Element;
  counter?: Element;
  figcaption?: Element;
  figure?: Element;
  image?: Element;
  imageInfos?: Element;
  nextLink?: HTMLAnchorElement | null;
  previousLink?: HTMLAnchorElement | null;
  social?: Element;
}

export interface GallerySize {
  SIZE_1COL?: string;
  SIZE_2COL?: string;
  SIZE_3COL?: string;
  SIZE_4COL?: string;
  SIZE_DEFAULT?: string;
  SIZE_FB?: string;
}

export interface MovieEntity {
  internalId?: string;
  title?: string;
}

interface PersonEntity {
  firstName?: string;
  internalId?: string;
  lastName?: string;
  seo?: { browsable?: boolean };
}

type EntityByType<T extends EntityTypes> = T extends 'Person'
  ? PersonEntity
  : T extends 'Movie'
    ? MovieEntity
    : never;

type EntityTypes = 'Movie' | 'Person';

type RelatedEntity<T extends EntityTypes> = {
  __typename: T;
} & EntityByType<T>;

interface GalleryGqlImageData {
  comments?: string;
  copyright?: string;
  movie?: string;
  person?: string;
  series?: string;
}

interface GalleryGqlImage {
  data?: GalleryGqlImageData;
  description?: string;
  path?: string;
  publicationDate?: string;
  relatedEntities?: RelatedEntity<EntityTypes>[];
}

export interface GalleryGqlItem {
  image?: GalleryGqlImage;
}

export interface FieldsInfosGql {
  className: string;
  field: keyof GalleryGqlImageData | keyof GalleryGqlImage;
  prefix: Node | null;
  transKey: string;
}

export const isReleaseDate = (value: any): value is ReleaseDate =>
  typeof value === 'object' && value.date;
export const isEntity = (value: any): value is Entity =>
  typeof value === 'object' && value.id;
export const isMovieEntity = (entity: any): entity is MovieEntity =>
  entity.__typename === 'Movie';
export const isPersonEntity = (entity: any): entity is PersonEntity =>
  entity.__typename === 'Person';
